/**
 * The main api service
 */
import http from '@util/http';
import {core} from '@api/req';

export async function queryRoleList(params) {
  return http.get(core.GET_ROLE_LIST, params);
}

export async function queryAllRoleList(params) {
  return http.get(core.GET_ROLE_LIST_ALL, params);
}

export async function queryRoleInfo(params) {
  return http.get(core.GET_ROLE_INFO, params);
}

export async function queryDeleteRole(params) {
  return http.get(core.DELETE_ROLE, params);
}

export async function querySaveRole(params) {
  return http.post(core.SAVE_ROLE, params);
}

export async function querySaveRoleFunc(params) {
  return http.post(core.SAVE_ROLE_FUNCTION, params);
}

export async function querySaveRoleUserByRole(params) {
  return http.post(core.SAVE_BY_ROLE_ACCOUNT_ROLE, params);
}

export async function queryAccountRoleAccounts(params) {
  return http.get(core.GET_ACCOUNT_ROLE_ACCOUNTS, params);
}

export async function queryRoleFunctionFunctionList(params) {
  return http.get(core.GET_ROLE_FUNCTION_FUNCTIONLIST, params);
}

export async function queryRoleFunctionRoleList(params) {
  return http.get(core.GET_ROLE_FUNCTION_ROLELIST, params);
}



// WEBPACK FOOTER //
// ./src/api/core/role.js